import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function CenterOrb() {
  return (
    <AnimatePresence>
      <motion.div
        data-testid="center-orb"
        style={{
          position: 'absolute',
          top: '42%', left: 0, right: 0, // Adjusted to 42% for better centering
          zIndex: 5,
          pointerEvents: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxSizing: 'border-box',
        }}
        initial={{ opacity: 0, scale: 0.6 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.6 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
      >
        <div style={{ position: 'relative', width: 340, height: 200, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {/* Outer halo */}
            <div style={{
              position: 'absolute',
              width: '100%', height: 200,
              borderRadius: '50%',
              background: 'radial-gradient(ellipse, rgba(255,255,255,0.06) 0%, transparent 70%)',
              filter: 'blur(30px)',
            }} />

            {/* Main glow capsule - contained horizontal movement */}
            <motion.div
              style={{
                position: 'absolute',
                width: 260, height: 120,
                borderRadius: 60,
                background: 'linear-gradient(135deg, rgba(255,255,255,0.38), rgba(200,180,255,0.28), rgba(232,66,148,0.18), rgba(167,21,233,0.12))',
                filter: 'blur(20px)',
              }}
              animate={{
                x: [0, 15, 0, -8, 0],
                y: [0, -4, 2, -2, 0],
                opacity: [0.85, 1, 0.88, 0.95, 0.85],
              }}
              transition={{ duration: 5, repeat: Infinity, ease: 'easeInOut' }}
            />

            {/* Bright inner core */}
            <motion.div
              style={{
                position: 'absolute',
                width: 180, height: 70,
                borderRadius: 35,
                background: 'linear-gradient(90deg, rgba(255,255,255,0.55), rgba(255,255,255,0.35), rgba(220,186,255,0.28))',
                filter: 'blur(14px)',
              }}
              animate={{
                opacity: [0.65, 1, 0.65],
                x: [0, 10, 0, -5, 0],
              }}
              transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}
            />

            {/* Glass text - CENTERED on capsule */}
            <motion.div
              style={{
                position: 'absolute',
                whiteSpace: 'nowrap',
                padding: '14px 28px',
                borderRadius: 24,
                background: 'rgba(255,255,255,0.22)',
                backdropFilter: 'blur(16px)',
                WebkitBackdropFilter: 'blur(16px)',
                border: '1px solid rgba(255,255,255,0.08)',
                color: 'rgba(255,255,255,0.95)',
                fontSize: 14,
                fontWeight: 600,
                letterSpacing: 0.3,
              }}
              animate={{
                y: [0, -3, 0],
                x: [0, 5, 0, -3, 0],
              }}
              transition={{ duration: 5, repeat: Infinity, ease: 'easeInOut' }}
            >
              What's on your mind?
            </motion.div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
